// @flow
import axios from 'axios'
import appConfig from './configs/app'
import externalAppConfig from './configs/extrernal-app'

export const buildAxiosConfig = () => {
  return process.env.REACT_APP_EXTERNAL === 'true' ? externalAppConfig : appConfig
}

/**
 * Create axios instance
 * @return {Axios} axios instance
 */
export const createAxiosInstance = () => {
  return axios.create(buildAxiosConfig())
}
